export const resetPasswordMarkup = String.raw`<!-- ====== RESET PASSWORD OVERLAY ====== -->
<div class="modal-overlay" id="resetPasswordOverlay" style="z-index:10010;">
  <div class="modal modal-auth modal-auth-narrow">
    <div class="modal-auth-topbar">
      <div class="modal-auth-brand">
        <img class="auth-brand-logo" src="/assets/brand/deepmox-wordmark-320.png" alt="DeepMox">
      </div>
      <button type="button" class="modal-close" data-proto-click="closeResetPasswordOverlay()" aria-label="Close reset password">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div id="resetPasswordChecking" class="modal-auth-body" style="display:none;text-align:center;padding:20px 0;">
      <div class="auth-spinner" style="margin:0 auto 16px;"></div>
      <h4 class="forgot-success-title">Checking link...</h4>
      <p class="forgot-success-detail">Please wait while we verify this password reset link.</p>
    </div>
    <div id="resetPasswordForm" class="modal-auth-body">
      <div class="modal-auth-header" style="margin-bottom:16px;">
        <h3 class="modal-auth-title">Reset Your Password</h3>
      </div>
      <div class="auth-field">
        <label class="wizard-label">New Password</label>
        <input type="password" class="input" id="resetNewPassword" placeholder="At least 8 characters" autocomplete="new-password" minlength="8" maxlength="128">
      </div>
      <div class="auth-field">
        <label class="wizard-label">Confirm Password</label>
        <input type="password" class="input" id="resetConfirmPassword" placeholder="Re-enter password" autocomplete="new-password" minlength="8" maxlength="128">
      </div>
      <div class="auth-pw-hint" style="font-size:12px;color:var(--fg-secondary);margin-bottom:12px;line-height:1.5;">
        Use at least 8 characters. A long, unique passphrase is recommended.
      </div>
      <p id="resetPasswordFormAlert" class="auth-form-alert" role="alert" aria-live="assertive" hidden></p>
      <button class="btn btn-primary btn-lg w-full auth-primary-btn" id="resetSubmitBtn" data-proto-click="handleResetPassword()">Reset Password</button>
    </div>
    <div id="resetPasswordSuccess" class="modal-auth-body" style="display:none;text-align:center;padding:20px 0;">
      <div class="forgot-success-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--success)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </div>
      <h4 class="forgot-success-title" id="resetPasswordSuccessTitle">Password reset!</h4>
      <p class="forgot-success-detail" id="resetPasswordSuccessDetail">Your password has been successfully changed. Redirecting to login...</p>
    </div>
    <div id="resetPasswordError" class="modal-auth-body" style="display:none;text-align:center;padding:20px 0;">
      <div class="forgot-success-icon" style="color:var(--error);">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--error)" stroke-width="2.5"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
      </div>
      <h4 class="forgot-success-title">Link expired</h4>
      <p class="forgot-success-detail">This password reset link is invalid or has expired. Please request a new one.</p>
      <button class="btn btn-primary btn-lg w-full auth-primary-btn" data-proto-click="closeResetPasswordOverlay();showForgotModal();return false;">Request new link</button>
    </div>
    <div id="resetPasswordValidationError" class="modal-auth-body" role="alert" aria-live="assertive" style="display:none;text-align:center;padding:20px 0;">
      <div class="forgot-success-icon" style="color:var(--warning);">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 9v4"></path><path d="M12 17h.01"></path><path d="M10.3 3.6 1.8 18.2A2 2 0 0 0 3.5 21h17a2 2 0 0 0 1.7-2.8L13.7 3.6a2 2 0 0 0-3.4 0Z"></path></svg>
      </div>
      <h4 class="forgot-success-title">Could not check link</h4>
      <p class="forgot-success-detail" id="resetPasswordValidationErrorDetail">We could not check this link because of a connection problem. Please try again.</p>
      <button class="btn btn-primary btn-lg w-full auth-primary-btn" data-proto-click="retryResetPasswordValidation()">Try again</button>
    </div>
    <div id="resetPasswordLoading" class="modal-auth-body" style="display:none;text-align:center;padding:20px 0;">
      <div class="auth-spinner" style="margin:0 auto 16px;"></div>
      <h4 class="forgot-success-title">Resetting password...</h4>
      <p class="forgot-success-detail">Please wait while we update your password.</p>
    </div>
  </div>
</div>`;
